import React, { useState, useRef, useEffect, useCallback } from "react";
import styles from "./chat.module.css";
import { chat, uploadFiles, chatHistory, deleteChat, reAuth, use_token, Logout } from "../../api";
import Viewer from "../../components/DocViewer/viewer";
import LandingPage from "../../components/LandingPage/LandingPage";
import { chatStyles } from "../../utils";
import ChatBot, { ChatBotProvider, useFlow, usePaths, useTextArea, useToast, useMessages } from "react-chatbotify";
import {
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Drawer,
    IconButton,
    CircularProgress,
    Alert,
    Tooltip,
    Grid,
    Box,
    Snackbar,
    SnackbarCloseReason
} from "@mui/material";
import {
    Delete as DeleteIcon,
    DescriptionOutlined as DescriptionOutlinedIcon,
    Close as CloseIcon,
    Menu as MenuIcon,
    FileDownload as FileDownloadIcon
} from "@mui/icons-material";
import Textarea from "@mui/joy/Textarea";

// import Markdown from "react-markdown";
import Markdown from 'markdown-to-jsx'
import remarkGfm from "remark-gfm";
import remarkRehype from "remark-rehype";
import remarkParse from "remark-parse";

import searchIcon from "../../assets/images/search.svg";
import attachment from "../../assets/images/attachment.png";
import sendIcon from "../../assets/images/send_icon.png";
import Dots from "../../assets/images/dots.png";
import AllDocumentsIcon from "../../assets/documents/AllDocument.png";
import LightBulb from "../../assets/chat/lightbulb.png";
import CommentIcon from "../../assets/navbar/chat.png";
import deleteIcon from "../../assets/navbar/delete.png";
import KPMGLogo from "../../assets/kpmg.svg";
import Expand from "../../assets/navbar/expand.png";
import Collapse from "../../assets/navbar/collapse.png";
import LogOut from "../../assets/navbar/LogOut.png";
import AddIcon from "../../assets/Add.png";
import DeleteModalIcon from "../../assets/DeleteModalIcon.png";
import Success from "../../assets/success.png";

interface Props {
    logoClicked: boolean;
    setLogoClicked: React.Dispatch<React.SetStateAction<boolean>>;
    appTitleVisible: boolean;
    setAppTitleVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const MyChatBotWrapper = ({ logoClicked, setLogoClicked, appTitleVisible, setAppTitleVisible }: Props) => {
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [files, setFiles] = useState<File[]>();
    const [threadID, setThreadID] = useState(undefined);
    const [choice, setChoice] = useState(undefined);
    const [response, setResponse] = useState(undefined);
    const [allFiles, setAllFiles] = useState([]);
    const [initiateChat, setInitiateChat] = useState(true);
    const [activeDoc, setActiveDoc] = useState("");
    const [showDoc, setShowDoc] = useState(false);
    const [error, setError] = useState("");
    const [feedback, setFeedback] = useState("");
    const [enableAttachment, setEnableAttachment] = useState(false);
    const [fileNames, setFileNames] = useState([]);
    const [downloadFiles, setDownloadFiles] = useState([]);
    const [prevChatHistort, setPrevChatHistort] = useState([]);
    const [showPrevChat, setShowPrevChat] = useState([]);
    const [prevChatSpinner, setPrevChatSpinner] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    const [chatTitle, setChatTitle] = useState("");
    const [openTitlePopup, setOpenTitlePopup] = useState(false);
    const [openDeletePopup, setOpenDeletePopup] = useState(false);
    const [chatObejct, setChatObject] = useState({});
    const [landingPage, setLandingPage] = useState(true);
    const [tooltipOpen, setTooltipOpen] = useState(true);
    const [sidebarExpanded, setSidebarExpanded] = useState(false);
    const [canvasStyle, setCanvasStyle] = useState("");
    const [deleteSuccess, setDeleteSuccess] = useState(false);
    const [chatTitleContainer, setChatTitleContainer] = useState("");
    const [feedbackCounter, setFeedbackCounter] = useState(0);
    const [nextStage, setNextStage] = useState("")

    const textareaRef = useRef<HTMLTextAreaElement | null>(null);
    const inputFile = useRef(null);
    const gridRef = useRef<HTMLDivElement>(null);
    const { showToast, dismissToast, toasts } = useToast();
    const { goToPath } = usePaths();
    const { restartFlow } = useFlow();
    const { setTextAreaValue } = useTextArea();
    const { injectMessage } = useMessages();

    const totalSteps = 5;
    const message = `Only ${6- feedbackCounter} feedback${6- feedbackCounter !== 1 ? 's' : ''} left for this stage`;
    const nextStep = `${nextStage}`;
    const progressPercentage = ((6 - feedbackCounter) / 5) * 100;  


    const handleDrawerToggle = filename => {
        setActiveDoc(filename);
        setShowDoc(true);
    };

    const handleDownloadToggle = () => {
        setMobileOpen(prevState => !prevState);
        setShowDoc(false);
    };

    // handling flow after starting process
    const handleFlow = async params => {
        let payload;
        if (
            params.prevPath === "provide_feedback" ||
            params.prevPath === "loop" ||
            params.prevPath === "first_response" ||
            params.prevPath === "prev_chat_list_files"
        ) {
            payload = params.userInput;
        } else if (params.userInput === "Continue") {
            payload = "continue";
        } else {
            payload = params.files;
        }

        try {
            const response = await chat(payload, initiateChat, threadID, feedbackCounter);
            if (response.current_state === "hold") {
                setInitiateChat(true);
            } else {
                setInitiateChat(false);
            }
            setFeedback(response.ask_user);
            setFeedbackCounter(response.counter);
            setNextStage(response.next_stage)
            if (response.message == "") {
                params.goToPath("end");
            } else {
                let data = (
                    <div className={`${styles.answerText}`}>
                        <Markdown>{response.message}</Markdown>
                    </div>
                );
                params.injectMessage(data);
                setTimeout(() => {
                    params.goToPath("provide_feedback");
                }, 1000);
            }

            let file_links = [...downloadFiles];
            if (response?.output_blob) {
                file_links.push(response?.output_blob);
            }
            setDownloadFiles(file_links);

            setResponse(response.message);
            setThreadID(response.thread_id);
        } catch (e) {
            setError(e);
        }
    };

    const handleDeleteChat = async id => {
        try {
            const response = await deleteChat(id);
            if (response.status == 'success') {
                console.log(response.message);
                handlePrevChat("");
                handleDeleteTitlePopup();
                setTimeout(() => {
                    setDeleteSuccess(false);
                }, 3000);
            } else {
                console.error("Failed to delete chat");
            }
        } catch (e) {
            setError(e);
        }
    };

    // handle previous chats
    const handlePrevChat = async (id = "") => {
        try {
            if (id == "") {
                setPrevChatSpinner(true);
            }
            const response = await chatHistory(id);
            if (use_token && (response.message == "Token expired" || response.message == "Sign In with proper Tenant")) {
                const get_link = await reAuth();
                window.location.href = get_link.auth_url;
            } else {
                if (id == "") {
                    let dt = response.data;
                    setPrevChatHistort(dt);
                    setPrevChatSpinner(false);
                } else {
                    setShowPrevChat(response.data);
                    setChatTitleContainer(response.data.conv_title);
                    setAllFiles(response.data.blob_files);
                    let file_links = [];
                    for (let msg of response.data.messages) {
                        if (msg?.blob_url != "" && msg?.blob_url != null) {
                            file_links.push(msg?.blob_url);
                        }
                    }
                    setDownloadFiles(file_links);
                    setThreadID(response.data.conv_id);
                    if (response.data.messages.length == 0) {
                        setInitiateChat(true);
                    } else {
                        setInitiateChat(false);
                    }
                    setLandingPage(false);
                    setSidebarExpanded(false);
                    setAppTitleVisible(true);
                    goToPath("prev_chat_list_files");
                    setLogoClicked(false);
                }
            }
        } catch (e) {
            setError(e);
        }
    };

    // handling files upload
    const handleUploadFiles = async event => {
        const files = event.target.files;
        let name_array = [];
        for (let file in files) {
            if (files[file].name != undefined && files[file].name != "item") {
                name_array.push(files[file].name);
            }
        }
        setFileNames(name_array);
        try {
            showToast("Uploading transcripts ...");
            const response = await uploadFiles(files, chatTitle);
            if (use_token && (response.message == "Token expired" || response.message == "Sign In with proper Tenant")) {
                const get_link = await reAuth();
                window.location.href = get_link.auth_url;
            } else {
                goToPath("first_response");
                setAllFiles(response.data.files);
                setThreadID(response.data.thread_id);
                setEnableAttachment(true);
            }
        } catch (e) {
            setError(e);
        }
    };

    // component for listing uploading files
    const ListFiles = () => {
        const fileListMSG = Object.values(fileNames).map(files => {
            return (
                <li onClick={() => handleDrawerToggle(files)} className={styles.listFilenamesContainer}>
                    <DescriptionOutlinedIcon fontSize="medium" color="inherit" className={styles.listFileIcon} />
                    {files}
                </li>
            );
        });
        return (
            <div className={styles.listDocumentsContainer}>
                <div className={styles.listDocumentsHeaderContainer}>
                    <h6 className={styles.listDocumentsHeader}>List of documents uploaded:</h6>
                    <ul className={styles.listDocumentsUL}>{fileListMSG}</ul>
                </div>
            </div>
        );
    };

    // component for listing uploading files
    const ListPrevFiles = () => {
        const fileListMSG = Object.values(showPrevChat.blob_files).map(files => {
            return (
                <li onClick={() => handleDrawerToggle(files.filename)} className={styles.listFilenamesContainer}>
                    <DescriptionOutlinedIcon fontSize="medium" color="inherit" className={styles.listFileIcon} />
                    {files.filename}
                </li>
            );
        });
        return (
            <div className={styles.listDocumentsContainer}>
                <div className={styles.listDocumentsHeaderContainer}>
                    <h6 className={styles.listDocumentsHeader}>List of documents uploaded:</h6>
                    <ul className={styles.listDocumentsUL}>{fileListMSG}</ul>
                </div>
            </div>
        );
    };

    const ListPrevChat = () => {
        let msg = showPrevChat.messages;
        var msg_data = msg;
        for (let type of msg_data) {
            if (type.owner === "user") {
                injectMessage(
                    <div className={styles.answerChatBubbleContainer}>
                        <div className={styles.answerChatBubble}>
                            <h6 className={styles.answerChatBubbleText}>{type.content}</h6>
                        </div>
                    </div>
                );
            } else {
                if (type.content == "") {
                    injectMessage(`Thank you for your time! 
We have finished processing all steps. 
                    
Please click on 'New Chat' to start a new conversation.`);
                } else {
                    injectMessage(
                        <div className={`${styles.answerText}`}>
                            <Markdown >{type.content}</Markdown>
                        </div>
                    );
                }
            }
        }
        return null;
    };

    // chat bot flow for showing data
    const flow = {
        start: {
            message: `Greetings from the Requirements Elicitation Agent

Upload your files, and I’ll guide you through each stage to create a polished, detailed requirements document. 

Let’s get started!`,
            chatDisabled: true
        },
        first_response: {
            component: () => <ListFiles />,
            message: params => {
                params.injectMessage('Please type "Process project documents" when you are ready');
                dismissToast(toasts[0].id);
            },
            chatDisabled: false,
            path: "loop"
        },
        prev_chat_list_files: {
            component: () => <ListPrevFiles />,
            message: params => {
                params.injectMessage('Please type "Process project documents" when you are ready');
            },
            chatDisabled: true,
            transition: 1000,
            path: "prev_chat_data"
        },
        prev_chat_data: {
            component: () => <ListPrevChat />,
            chatDisabled: false,
            function: async params => {
                await handleFlow(params);
            }
        },
        loop: {
            message: async params => {
                await handleFlow(params);
            }
        },

        provide_feedback: {
            component: (
                <div style={{ marginTop: "8px" }}>
                    <div className={`${styles.show_suggestion}`}>
                        <img src={LightBulb} />
                        <p>
                            Feel free to point out any adjustments needed for the <br /> {feedback?.split("feedback on ")[1]}{" "}
                        </p>
                    </div>
                    <div className={`${styles.show_suggestion}`}>
                        <img src={LightBulb} />
                        <p>If there are no further changes needed, please give us the go-ahead to proceed to the next step.</p>
                    </div>
                    {/* <div className={`${styles.show_counter}`}>
                        <p>You have {6 - feedbackCounter} feedbacks left for this stage</p>
                    </div> */}
                    <div className={styles.progressContainer}>
                        <div className={styles.progressInfo}>
                            <span>{message}</span>
                            <span>Up next: {nextStep}</span>
                        </div>
                        <div className={styles.progressBar}>
                            <div className={styles.filledProgress} style={{ width: `${progressPercentage}%` }} />
                        </div>
                    </div>
                </div>
            ),
            chatDisabled: false,
            path: "loop"
        },
        continue: {
            message: async params => {
                await handleFlow(params);
            }
        },
        end: {
            message: params => `Thank you for your time! 
We have finished processing all steps. 

Please click on 'New Chat' to start a new conversation.`,
            chatDisabled: true
        }
    };

    const showFileName = file => {
        let name = file.split("/");
        return name[name.length - 1]?.replaceAll("_", " ");
    };

    const prevChatList = () => {
        const filteredChatHistort = prevChatHistort.filter(chat => (chat.conv_title || `chat`).toLowerCase().includes(searchInput.toLowerCase()));

        if (!prevChatSpinner) {
            if (filteredChatHistort.length > 0 && prevChatHistort != null) {
                return filteredChatHistort.map((chats, index) => (
                    <div key={index} className={`${styles.prev_chat_div}`}>
                        <div
                            className={styles.chatHistoryChatbubbleContianer}
                            onClick={() => {
                                handlePrevChat(chats.conv_id);
                                resetChatFlow();
                            }}
                        >
                            <span className={styles.chatHistoryChatIconContainer}>
                                <img src={CommentIcon} alt="prev chat" className={styles.chatHistoryChatIcon} />
                            </span>
                            <div className={styles.chatHistoryChatTextContainer}>
                                <p className="mb-0">{chats?.conv_title == null || chats?.conv_title == "" ? `chat ${index}` : chats.conv_title}</p>
                            </div>
                        </div>
                        <span className={styles.chatHistoryDeleteContainer} onClick={() => handleDeleteIcon(chats)}>
                            <img src={deleteIcon} alt="prev chat" height={"13px"} width={"13px"} />
                        </span>
                    </div>
                ));
            } else {
                return <p className={styles.noChatMessage}>No Chat exists</p>;
            }
        } else {
            return (
                <div className={styles.chatHistoryLoader}>
                    <CircularProgress color="secondary" style={{ color: "rgba(233, 234, 252, 1)" }} />{" "}
                </div>
            );
        }
    };

    const resetChatFlow = () => {
        restartFlow();
        setShowDoc(false);
        setTextAreaValue("");
        setAllFiles([]);
        setActiveDoc("");
        setInitiateChat(true);
        setEnableAttachment(false);
        setFileNames([]);
        setDownloadFiles([]);
        if (inputFile.current) {
            inputFile.current.value = "";
            inputFile.current.type = "text";
            inputFile.current.type = "file";
        }
    };

    const handleOpenTitlePopup = useCallback(() => {
        setChatTitle("");
        setOpenTitlePopup(true);
    }, []);

    const handleCloseTitlePopup = useCallback(() => {
        setOpenTitlePopup(false);
        setChatTitle("");
    }, []);

    const handleCreateChat = useCallback(() => {
        if (chatTitle.trim() !== "") {
            setOpenTitlePopup(false);
            resetChatFlow();
            setLandingPage(false);
            setAppTitleVisible(true);
            setChatTitleContainer(chatTitle);
        } else {
            alert("Please enter a title for the chat.");
        }
    }, [chatTitle, handleCloseTitlePopup]);

    const handleChange = useCallback(e => {
        setChatTitle(e.target.value);
    }, []);

    const getXsValue = () => {
        if (mobileOpen) {
            return 8;
        } else if (showDoc) {
            return 6;
        } else {
            return 8;
        }
    };

    const handleDeleteTitlePopup = useCallback(() => {
        setOpenDeletePopup(false);
    }, []);

    const handleDeleteIcon = useCallback(chats => {
        setOpenDeletePopup(true);
        setChatObject(chats);
    });

    const handleLogout = async () => {
        try {
            const response = await Logout();
            if (response) {
                localStorage.removeItem("token");
                localStorage.removeItem("user_id");
                window.location.href = response.logout_url;
            } else {
                console.error("Failed to logout");
            }
        } catch (e) {
            setError(e);
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setTooltipOpen(false);
        }, 5000);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (openTitlePopup && textareaRef.current) {
            textareaRef.current.focus();
        }
    }, [openTitlePopup]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (gridRef.current && !gridRef.current.contains(event.target as Node)) {
                setLogoClicked(false);
            }
        };

        if (logoClicked) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [logoClicked, setLogoClicked]);

    useEffect(() => {
        sidebarExpanded ? handlePrevChat() : null;
        if (!sidebarExpanded) {
            setSearchInput("");
        }
    }, [sidebarExpanded]);

    const toggleSidebar = () => {
        setSidebarExpanded(!sidebarExpanded);
    };

    useEffect(() => {
        setCanvasStyle(`${styles.gridContainer} ${sidebarExpanded ? styles.expanded : ""}`);
    }, [sidebarExpanded]);

    return (
        <>
            <div className={`${styles.sidebarContainer} ${sidebarExpanded ? styles.expanded : ""}`}>
                <div className={styles.sidebarLogoContainer}>
                    <span className={`${styles.logoContainer} ${sidebarExpanded ? styles.expanded : ""}`} onClick={toggleSidebar}>
                        <img src={sidebarExpanded ? Collapse : Expand} alt="KPMG Logo" className={styles.collapse} />
                        <img src={KPMGLogo} alt="KPMG Logo" className={`${sidebarExpanded ? "" : styles.KPMGLogo} `} />
                    </span>
                </div>
                <div className={styles.sidebarItem}>{sidebarExpanded && <span className={styles.applicationHeading}>Requirements Elicitation Agent</span>}</div>
                {sidebarExpanded && (
                    <div ref={gridRef} className={styles.chatHistoryPanel}>
                        <div className={styles.searchContainer}>
                            <img src={searchIcon} alt="SearchIcon" className={styles.searchIcon} />
                            <input
                                type="text"
                                placeholder="Search chats"
                                value={searchInput}
                                onChange={e => setSearchInput(e.target.value)}
                                className={styles.searchInput}
                            />
                        </div>
                        <div className={`${styles.prev_chat_history}`}>{prevChatList()}</div>
                    </div>
                )}
                <div className={styles.logout}>
                    <div className={`${styles.logoutContainer} ${sidebarExpanded ? styles.expanded : ""}`} onClick={handleLogout}>
                        <img src={LogOut} alt="Logout Icon" className={styles.logoutIcon} />
                        {sidebarExpanded && <span>Logout</span>}
                    </div>
                </div>
            </div>
            <div className={styles.invisibleNavbar}>
                <div>
                    <span className={styles.dotsContainer}>
                        <img src={Dots} alt="Dots" onClick={handleDownloadToggle} className={styles.dotsIcon} />
                    </span>
                </div>
                <div>
                    <Tooltip
                        title="Click ‘New chat’ to start a conversation with the Agent."
                        arrow
                        open={tooltipOpen}
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    backgroundColor: "rgba(255, 255, 255, 1)",
                                    color: "rgba(1, 31, 86, 1)",
                                    maxWidth: 200,
                                    border: "1px solid #dadde9",
                                    boxShadow: "2px 2px 8px 0px rgba(0, 0, 0, 0.15)",
                                    fontSize: 12,
                                    padding: "10px",
                                    borderRadius: "15px",
                                    textAlign: "center"
                                }
                            },
                            arrow: {
                                sx: {
                                    color: "rgba(255, 255, 255, 1)"
                                }
                            }
                        }}
                    >
                        <button className={styles.new_chat} onClick={handleOpenTitlePopup}>
                            <img src={AddIcon} alt="plus icon" className={styles.addIcon} />
                            New Chat
                        </button>
                    </Tooltip>
                </div>
                <div className={`${styles.chatTitleContainer}  ${sidebarExpanded ? styles.expanded : ""}`}>
                    <span className={styles.chatTitle}>{chatTitleContainer}</span>
                </div>
            </div>

            {landingPage && <LandingPage sidebarExpanded={sidebarExpanded} />}

            <Grid container spacing={2} className={`${styles.gridContainer} ${sidebarExpanded ? styles.expanded : ""}`} style={{ marginTop: "0px" }}>
                <Grid className={styles.gridChat} item xs={getXsValue()} style={{ paddingLeft: "0px", paddingTop: "0px" }}>
                    <span
                        className={`${styles.file_up} ${showDoc ? styles.file_left : ""}`}
                        onClick={() => {
                            document.getElementById("click_file")?.click();
                        }}
                        style={{ pointerEvents: `${enableAttachment ? "none" : "auto"}`, opacity: `${enableAttachment ? 0.7 : 1}` }}
                    >
                        <img src={`${attachment}`} alt="file attach" className={styles.attachmentIcon} />
                        <input
                            className={styles.gridChatInput}
                            disabled={enableAttachment}
                            id="click_file"
                            multiple={true}
                            ref={inputFile}
                            onChange={e => handleUploadFiles(e)}
                            type="file"
                            accept=".doc, .docx"
                        />
                    </span>

                    <Dialog open={openDeletePopup} onClose={handleDeleteTitlePopup} style={{ borderRadius: "15px" }}>
                        <Box
                            sx={{
                                width: "400px",
                                boxShadow: 24,
                                outline: 0,
                                overflowY: "auto",
                                gap: 2,
                                border: false ? "2px dashed #000" : "2px solid transparent",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                paddingBottom: "30px",
                                paddingTop: "50px"
                            }}
                        >
                            <div className={styles.closeDiv} onClick={handleDeleteTitlePopup}>
                                <CloseIcon />
                            </div>
                            {deleteSuccess ? <img src={Success} alt="SuccessIcon" /> : <img src={DeleteModalIcon} alt="DeleteIcon" />}

                            <span className={styles.newDeleteModalSubtitle}>
                                {deleteSuccess ? "Your chat has been successfully deleted." : "Are you sure you want to delete this chat?"}
                            </span>
                            <DialogActions>
                                {deleteSuccess ? (
                                    ""
                                ) : (
                                    <button className={`${styles.createButton} ${styles.cancel}`} onClick={handleDeleteTitlePopup}>
                                        Cancel
                                    </button>
                                )}

                                {deleteSuccess ? (
                                    <button className={styles.createButton}>Done</button>
                                ) : (
                                    <button
                                        className={styles.createButton}
                                        onClick={() => {
                                            handleDeleteChat(chatObejct.conv_id);
                                            setDeleteSuccess(true);
                                        }}
                                    >
                                        Delete
                                    </button>
                                )}
                            </DialogActions>
                        </Box>
                    </Dialog>

                    <Dialog open={openTitlePopup} onClose={handleCloseTitlePopup} style={{ borderRadius: "15px" }}>
                        <Box
                            sx={{
                                width: "565px",
                                boxShadow: 24,
                                outline: 0,
                                overflowY: "auto",
                                gap: 2,
                                border: false ? "2px dashed #000" : "2px solid transparent",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                padding: "15px"
                            }}
                        >
                            <DialogTitle
                                style={{
                                    alignSelf: "baseline",
                                    width: "95%",
                                    borderBottom: "1px solid grey",
                                    marginLeft: "10px",
                                    marginRight: "10px",
                                    paddingLeft: "0px",
                                    color: "rgba(47, 47, 57, 1)"
                                }}
                            >
                                New Chat
                            </DialogTitle>
                            <div className={styles.closeDiv} onClick={handleCloseTitlePopup}>
                                <CloseIcon />
                            </div>
                            <span className={styles.newChatModalSubtitle}>Enter a chat title below to start conversing with the agent.</span>
                            <Textarea
                                sx={{ width: "510px" }}
                                color="neutral"
                                disabled={false}
                                minRows={4}
                                placeholder="Enter chat title here"
                                size="md"
                                variant="outlined"
                                value={chatTitle}
                                onChange={handleChange}
                            />
                            <DialogActions style={{ alignSelf: "end", padding: "0px" }}>
                                <button className={styles.createButton} onClick={handleCreateChat}>
                                    Create
                                </button>
                            </DialogActions>
                        </Box>
                    </Dialog>

                    <ChatBot
                        settings={{
                            general: { embedded: true },
                            chatHistory: { disabled: true },
                            header: {
                                title: <div></div>
                            },
                            footer: { text: "" },
                            fileAttachment: {
                                multiple: true,
                                accept: ".doc, .docx",
                                showMediaDisplay: true,
                                sendFileName: false
                            },
                            notification: {
                                disabled: true
                            },
                            emoji: {
                                disabled: true
                            },
                            event: {
                                rcbUserUploadFile: true
                            }
                        }}
                        flow={flow}
                        styles={chatStyles}
                    />
                </Grid>

                {showDoc && (
                    <Grid item xs={6} spacing={2} style={{ paddingTop: "0px" }}>
                        <div className={styles.doc_viewer}>
                            <div className={styles.gridDocumentContainer}>
                                {showDoc ? (
                                    <span
                                        className={styles.docCloseIcon}
                                        onClick={() => {
                                            setShowDoc(false);
                                        }}
                                    >
                                        <CloseIcon />
                                    </span>
                                ) : (
                                    ""
                                )}
                                {allFiles.map((doc, index) => (
                                    <div className={styles.activeDocContainer}>{activeDoc === doc.filename ? <Viewer docs={doc} /> : ""}</div>
                                ))}
                            </div>
                        </div>
                    </Grid>
                )}

                {mobileOpen && (
                    <Grid item xs={4} className={styles.gridAllDocuments} style={{ paddingTop: "0px" }}>
                        <div className={styles.mydocumentContainer}>
                            <div className={styles.allDocumentsContainer}>
                                <img src={AllDocumentsIcon} />
                                <span className={styles.heading}>All Documents</span>
                            </div>
                            <div className={styles.uploadedDocsContainer}>
                                <div className={styles.uploadedDocsHeader}>
                                    <span>Uploaded documents</span>
                                </div>
                                <div className={styles.uploadedFilesContainer}>
                                    <div className={styles.uploadedFiles}>
                                        {allFiles?.map((file, index) => (
                                            <a href={file?.url} target="_blank" download>
                                                <button className={`${styles.download_btn}`}>
                                                    <div className={styles.fileCard}>
                                                        <div className={styles.fileIcon}></div>
                                                        <span className={styles.fileName}>{file?.filename}</span>
                                                    </div>
                                                    <span className={styles.fileDownloadIconContainer}>
                                                        <img src={Dots} alt="Dots" onClick={handleDownloadToggle} className={styles.fileDownloadIcon} />
                                                    </span>
                                                </button>
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className={styles.GeneratedDocsContainer}>
                                <div className={styles.GeneratedDocsHeader}>
                                    <span>Generated documents</span>
                                </div>
                                <div className={styles.GeneratedFilesContainer}>
                                    <div className={styles.GeneratedFiles}>
                                        {downloadFiles.map((file, index) => (
                                            <a href={file} target="_blank" download>
                                                <button className={`${styles.download_btn}`}>
                                                    <div className={styles.fileCard}>
                                                        <div className={styles.fileIcon}></div>
                                                        <span className={styles.fileName}>{showFileName(file)}</span>
                                                    </div>

                                                    <span className={styles.fileDownloadIconContainer}>
                                                        <img src={Dots} alt="Dots" onClick={handleDownloadToggle} className={styles.fileDownloadIcon} />
                                                    </span>
                                                </button>
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <button className={styles.closeButton} onClick={handleDownloadToggle}>
                                Close
                            </button>
                        </div>
                    </Grid>
                )}
            </Grid>
        </>
    );
};

const MyChatBotProvider = (props: Props) => {
    return (
        <ChatBotProvider>
            <MyChatBotWrapper
                logoClicked={props.logoClicked}
                setLogoClicked={props.setLogoClicked}
                appTitleVisible={props.appTitleVisible}
                setAppTitleVisible={props.setAppTitleVisible}
            />
        </ChatBotProvider>
    );
};

const Chat = (props: Props) => {
    return (
        <MyChatBotProvider
            logoClicked={props.logoClicked}
            setLogoClicked={props.setLogoClicked}
            appTitleVisible={props.appTitleVisible}
            setAppTitleVisible={props.setAppTitleVisible}
        />
    );
};

export default Chat;
